<template>
  <div class="contain">
    <WorkOverview
      v-if="!planDetailStatus && modeType === '1'"
      :modeType="modeType"
      @changeModeType="changeModeType"
      @showPlanDetail="showPlanDetail"
    />
    <OverallDataOverview
      v-else-if="!planDetailStatus && modeType === '2'"
      :modeType="modeType"
      @changeModeType="changeModeType"
    />
  </div>
</template>

<script>
import WorkOverview from './components/WorkOverview'
import OverallDataOverview from './components/OverallDataOverview'

export default {
  name: 'Workbench',
  components: {
    WorkOverview,
    OverallDataOverview,
  },
  data() {
    return {
      modeType: '1',
      planDetailStatus: false,
      viewRecord: {},
    }
  },
  created() {},
  methods: {
    changeModeType(type) {
      this.modeType = type
    },
    showPlanDetail(data) {
      console.log('跳转信息：', data)
      this.$router.push({
        path: '/school/mentalHealth/PlanDetails',
        query: {
          id: data.id,
          tag: data.tag,
          title: data.title,
          gradeIds: data.gradeIds,
          classIds: data.classIds,
        },
      })
    },
  },
}
</script>
<style scoped lang="less">
.contain {
  min-height: 80vh;
  padding-bottom: 20px;
  background-color: #fff;
  border-radius: 10px;
}
</style>
